import { SymbolInfoColumns } from 'symbols/symbolInfo/columns';
import { useSymbolStaticData } from 'symbols/store/useSymbolStaticData';
import React, { useMemo } from 'react';
import { TextInput } from '@instinet-analytics/semantic-ui-components';
import { AutoSuggest } from '@instinet-analytics/core-lib';
import SymbolInput from 'symbols/components/SymbolInput';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';

export interface SymbolInfoValueEditorProps {
    attribute?: SymbolInfoColumns;
    value: string;
    onChanged: (nextValue: string) => void;
}

export function SymbolInfoValueEditor(props: SymbolInfoValueEditorProps) {
    const { attribute, value, onChanged } = props;

    const symbolStaticData = useSymbolStaticData();

    const staticData = useMemo(() => {
        return {
            assetClass: symbolStaticData.assetClasses,
            region: symbolStaticData.regions,
            country: symbolStaticData.countries,
            currencyCode: symbolStaticData.currencyCodes,
            industry: symbolStaticData.industries,
            sector: symbolStaticData.sectors,
            subIndustry: symbolStaticData.subIndustries,
            superSector: symbolStaticData.superSectors,
            securityType: symbolStaticData.secTypes,
        };
    }, [symbolStaticData]);

    switch (attribute) {
        case 'assetClass':
        case 'region':
        case 'country':
        case 'currencyCode':
        case 'industry':
        case 'sector':
        case 'subIndustry':
        case 'superSector':
        case 'securityType':
            return (
                <AutoSuggest
                    candidates={staticData[attribute] ?? []}
                    value={value}
                    onChange={onChanged}
                    getCandidateValue={(c) => c}
                    placeholder={''}
                    getComparisonString={(c) => c}
                />
            );
        case 'iSymbol':
            return (
                <SymbolInput
                    value={value}
                    onChange={onChanged}
                    symbology={SymbologyValues.Instinet}
                />
            );
        case 'bloomSymbol':
            return (
                <SymbolInput
                    value={value}
                    onChange={onChanged}
                    symbology={SymbologyValues.Bloomberg}
                />
            );

        default:
            return <TextInput value={value} onChange={onChanged} />;
    }
}
